// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__NqB7y","Icon--clickable":"Icon_Icon--clickable__fAa_3","Icon--inherit-colors":"Icon_Icon--inherit-colors__UMaUm"};